(function() {
    // 注册组件
    SR.component.extend('guideQuestions', guideQuestions);

    function guideQuestions() {
        if (SR.state.categoryGuide && typeof SR.data.guideQuestions.qs[0] === 'object') {
            $('.guide-questions').each(function (index, item) {
                var catagoryQuestions = SR.data.guideQuestions.qs[index];
                if (catagoryQuestions && catagoryQuestions.questions.length) {
                    new SR.component.questionSwither(catagoryQuestions.questions, {
                        element: '#guide-' + index,
                        button: '.J_changeQuestion',
                        buttonText: '换一换',
                        buttonAnimation: false
                    });
                }
            });
        } else {
            // 引导问题
            var questions = SR.data.guideQuestions.qs || SR.data.guideQuestions;
            if (SR.data.guideQuestions.tqs) {
                questions = SR.data.guideQuestions.tqs.concat(SR.util.shuffle(SR.data.guideQuestions.qs));
            } else {
                questions = SR.util.shuffle(questions);
            }
            new SR.component.questionSwither(questions, {
                element: '.guide-questions',
                title: '你可以问我：',
                button: '.J_changeQuestion',
                buttonText: '换一换',
                buttonAnimation: true,
                isRandom: false
            });
        }
    }
})();
